import type {
  Coding,
  Patient,
  Practitioner,
  Reference,
} from '@medplum/fhirtypes'
import { SEEN_HEALTH_SYSTEM } from '#src/codeSystems.ts'
import { Tag } from '#src/decorators.ts'
import { ParticipantNote } from '#src/models/participantNote.ts'
import type { QueryTypes } from '#src/search.ts'

const MEMO_TAG_SYSTEM = `${SEEN_HEALTH_SYSTEM}/composition-subtype`
const MEMO_TAG_CODE = 'memo'

export class MemoNote extends ParticipantNote {
  @Tag({
    system: MEMO_TAG_SYSTEM,
  })
  _memoTag?: Coding

  constructor({
    participant,
    author,
  }: {
    participant: Reference<Patient>
    author: Reference<Practitioner>
  }) {
    super({
      participant,
      content: '',
      author,
    })
    this._memoTag = {
      system: MEMO_TAG_SYSTEM,
      code: MEMO_TAG_CODE,
    }
  }

  static override queryByParticipant(ref: Reference<Patient>): QueryTypes {
    return {
      _tag: `${MEMO_TAG_SYSTEM}|${MEMO_TAG_CODE}`,
      subject: ref,
      'status:not': 'entered-in-error',
      _count: '1',
    }
  }
}
